import { Content } from '../../types';

export const visaContent: Content = {
  title: 'ויזה לוייטנאם – כל מה שצריך לדעת!',
  imageUrl: '/images/vietnam/visa/visa-wide.jpeg',
  introduction:
    'בעלי דרכון ישראלי נדרשים לויזה על מנת להיכנס לוייטנאם. קיימות מספר דרכים להוצאת הויזה, בהתאם לסוג הביקור ואופן הכניסה למדינה.',
  sections: [
    {
      title: 'הוצאת ויזה מראש (באמצעות האינטרנט – e-Visa)',
      type: 'list',
      content: [
        {
          subtitle: 'פרטי הויזה',
          text: 'ישראלים יכולים להוציא ויזה אלקטרונית (e-Visa) מראש דרך אתר רשויות ההגירה של וייטנאם. מדובר באפשרות הנוחה והפשוטה ביותר למטיילים.\n\nתוקף הויזה: 90 יום מיום האישור (לשהייה של עד 30 או 90 יום, בהתאם לבקשה).\nסוג הויזה: ניתן להוציא ויזת כניסה חד-פעמית או רב-פעמית.\nעלות הויזה: כניסה חד פעמית - 25 דולר, כניסה רב פעמית – 50 דולר (תשלום מקוון).',
        },
        {
          subtitle: 'נקודות כניסה מאושרות',
          text: "✔ שדות התעופה הבינלאומיים: האנוי (Noi Bai), הו צ'י מין סיטי (Tan Son Nhat), דה נאנג ועוד.\n✔ מעברי גבול יבשתיים נבחרים עם קמבודיה, לאוס וסין.",
        },
        {
          subtitle: 'מסמכים נדרשים',
          text: 'דרכון בתוקף לפחות ל - 6 חודשים ממועד הכניסה.\nתמונת פספורט דיגיטלית על רקע בצבע לבן.\nסריקת עמוד הדרכון הראשי.\nאמצעי תשלום (כרטיס אשראי/דביט).\nזמן טיפול: כ – 5 ימי עסקים (מומלץ בחום לקחת מרווח זמן רחב יותר – לפחות שבועיים).',
        },
      ],
    },
    {
      title: 'הוצאת ויזה בעת ההגעה (Visa on Arrival) – דורשת מכתב אישור מראש',
      type: 'list',
      content: [
        {
          subtitle: 'מידע כללי',
          text: 'ויזה בעת ההגעה אפשרית רק אם מזמינים מראש "מכתב אישור לויזה" (Approval Letter) דרך סוכנות נסיעות רשומה. עם הצגת המכתב לפקידי ההגירה בעת ההגעה למדינה, ניתן לקבל את הויזה בשדות התעופה.\n\nעלות מכתב האישור: כ- 10– 20 דולר (משתנה לפי הסוכנות).\nעלות הויזה בעת ההגעה:\n- כניסה חד-פעמית – 25 דולר.\n- כניסה רב-פעמית – 50 דולר.\nתוקף הויזה: עד 30 או 90 יום, בהתאם לבקשה.',
        },
        {
          subtitle: 'נקודות כניסה מאושרות',
          text: 'בשדות התעופה הבינלאומיים בלבד (לא בגבולות יבשתיים!).',
        },
        {
          subtitle: 'מסמכים נדרשים בעת הנחיתה',
          text: '- דרכון בתוקף 6 חודשים לפחות.\n- 2 תמונות פספורט מודפסות.\n- מכתב אישור מודפס.\n- תשלום במזומן (דולרים בלבד).',
        },
        {
          subtitle: 'שימו לב',
          text: 'ויזה זו מתאימה למגיעים בטיסה בלבד. המתכננים להגיע באמצעות מעבר יבשתי, נדרשים להוציא e-Visa מראש!',
        },
      ],
    },
    {
      title: 'פטור מויזה – מי לא צריך ויזה?',
      type: 'text',
      content:
        'אזרחי מדינות מסוימות (יפן, דרום קוריאה, רוסיה, בלארוס, גרמניה, צרפת, בריטניה, דנמרק, פינלנד, נורבגיה, איטליה, רוסיה, ספרד, שבדיה, קמבודיה, אינדונזיה, קירגיזסטן, סינגפור, תאילנד, לאוס, מלזיה) זכאים לכניסה ללא ויזה לפרקי זמן שונים.\n\nישראלים אינם זכאים לפטור מויזה ונדרשים להוציא ויזה מראש.',
    },
    {
      title: 'הארכת ויזה בוייטנאם',
      type: 'text',
      content:
        'נכון לשעה, לא ניתן להאריך ויזה אלקטרונית מעבר ל – 90 יום אותם היא מאפשרת עבור שהייה במדינה ועם זאת, ניתן לצאת מהמדינה, להגיש בקשה חדשה לויזה ולחזור מייד עם קבלתה. עם זאת, סוגיה זו משתנה לעיתים ומומלץ לבדוק למול הסוכנויות המקומיות את האופציות העדכניות, התנאים והעלויות.',
    },
    {
      title: 'ויזה דחופה',
      type: 'text',
      content:
        'במקרה בו טיסתכם קרבה ואין ברשותכם ויזה/ מכתב אישור לויזה, ניתן להגיש בקשה לויזה דחופה, באמצעות סוכנות רלוונטית. מחיר השירות תלוי בסוכנות הספציפית, הויזה תקפה ל – 30 בלבד ובאמצעות מעברי הגבול האוויריים בלבד.',
    },
    {
      title: 'האי פוקוק',
      type: 'text',
      content:
        'המבקשים להגיע לאי פוקוק בלבד, בין אם בטיסה ישירה ובין אם בטיסה עם עצירת ביניים בשדה תעופה אחר במדינה אך ללא יציאה ממנו, בהלוך ובחזור, אינם נדרשים לויזה ויקבלו אשרה לשהייה של עד 30 יום עם הנחיתה בשדה התעופה הבינלאומי של האי.',
    },
    {
      title: 'שורה תחתונה',
      type: 'list',
      content: [
        {
          text: '✔ האפשרות המומלצת: הוצאת e-Visa מראש באתר הרשמי – תהליך פשוט, מהיר וזול.',
        },
        {
          text: '✔ למגיעים בטיסה ומעוניינים באופציה גמישה – Visa on Arrival אפשרית, אך דורשת מכתב אישור מראש.',
        },
        {
          text: '✔ למתכננים להיכנס דרך מעבר יבשתי – חובה להוציא e-Visa מראש.',
        },
        {
          text: '✔ לא ניתן לעלות על הטיסה הנוחתת בוייטנאם ללא ויזה/ מכתב אישור לויזה.',
        },
      ],
    },
    {
      title: 'לתשומת לב המטיילים',
      type: 'text',
      content:
        'אם הינכם מתכננים להיכנס ולצאת מוייטנאם יותר מפעם אחת (למשל, לטייל במדינות שכנות ולחזור), שווה לבחון הוצאת ויזה רב-פעמית.\n\nנסיעה טובה! ✈',
    },
  ],
};
